import React from 'react'
import styled from 'styled-components'
import EloIcon from '../../custom-icons/elo-icon.component'
import AmexIcon from '../../custom-icons/amex-icon.component'
import VisaIcon from '../../custom-icons/visa-icon.component'
import cardBrand from './../../../constants/card-brand.constants'
import PureSelect from '../pure-select.component'
import RadioButton from '../radio-button.component'
import HipercardIcon from '../../custom-icons/hipercard-icon.component'
import MasterCardIcon from '../../custom-icons/master-card-icon.component'
import { connect } from 'react-redux'
import { breakpoints } from '../../../constants'
import { StyledContent } from '../payment-fields/styled-content.style'
import { StyledCardFields } from '../payment-fields/styled-card-fields.style'
import { CheckboxToggleInput } from './../../../components/form-components/inputs.component'
import { Creators as CreditCardPurchaseCreators } from '../../../ducks/credit-card-purchase/credit-card-purchase'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import {
	AmexCreditCardInput,
	CreditCardInput,
	SecurityCodeInput,
	TextInput
} from '../inputs.component'
import { getCreditCardInstallmentOptions } from '../../../modules/private/client/ticket-sale/creditcard-installment-options'
import { mapApiInstallments } from '../../../helpers'
import { toastActions } from '../../../actions/toast.actions'

const StyledPaymentMethodsButtons = styled.div`
	display: flex;
	flex-wrap: nowrap;

	& > div {
		flex-grow: 1;
		padding: 8px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex-grow: initial;
			padding: 15px;
		}

		img {
			max-width: 30px;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				max-width: 100%;
			}
		}
	}
`

const StyledFieldsContainer = styled.div`
	.validity-field {
		${({ noSecurityCode }) => noSecurityCode && 'grid-column: 1 / 3'};
	}

	.validity-field:last-child {
		${({ noSecurityCode }) => noSecurityCode && 'grid-column: 3 / 5'};
	}
`

export const cardYearValidityOptions = (function() {
	let options = []
	let currentYear = new Date().getFullYear()
	const yearsRange = 11

	for (let i = 0; i <= yearsRange; i++)
		options.push({
			value: currentYear - 2000,
			label: currentYear++
		})

	return options
})()

const MAX_INSTALLMENT_FETCH_RETRIES = 3

class CreditCardFields extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedCardBrand: this.props.values.cardBrand || cardBrand.mastercard,
			isGettingCreditCardInstallmentOptions: false,
			fetchedCreditCardInstallmentOptions: false
		}
		this.installmentFetchRetries = 0
	}

	componentWillUnmount() {
		this._isMounted = false
		this.props.setInstallmentsOptions([])
		this.props.setInstallmentsQtt(1)
	}

	selectCardBrand = value => {
		this.props.setCardBrand(value)
		this.props.setFieldValue('cardBrand', value)
		this.setState({ selectedCardBrand: value })
	}

	recurrentPayDayOptions = [
		{ value: 5, label: '5' },
		{ value: 15, label: '15' },
		{ value: 25, label: '25' }
	]

	async fetchInstallmentOptions(orderValue, showToast = true) {
		if (!this._isMounted) return

		const {
			installmentsQtt,
			apiInstallments,
			apiPaymentMethodsLoading,
			disableLegacyInstallments
		} = this.props

		if (apiPaymentMethodsLoading) return

		if (!apiInstallments && disableLegacyInstallments) {
			// Checkout novo: payments/methods do carrinho e fonte unica - sem
			// fallback pro endpoint legado (evita loop de retry sem sentido).
			this.setState({
				isGettingCreditCardInstallmentOptions: false,
				fetchedCreditCardInstallmentOptions: true
			})
			this.props.setInstallmentsOptions([])
			return
		}

		if (apiInstallments) {
			const creditCardInstallmentsOptions = mapApiInstallments(
				apiInstallments,
				orderValue,
				{ showAVista: true }
			)

			this.setState({
				isGettingCreditCardInstallmentOptions: false,
				fetchedCreditCardInstallmentOptions: true
			})

			this.props.setInstallmentsOptions(creditCardInstallmentsOptions)

			const optionExists = creditCardInstallmentsOptions.some(
				opt => String(opt.value) === String(installmentsQtt)
			)

			if (installmentsQtt && optionExists) {
				this.props.setFieldValue('installments', installmentsQtt)
				this.setInterestValue(installmentsQtt)
			} else {
				this.props.setInstallmentsQtt(null)
				this.props.setFieldValue('installments', '')
			}

			return
		}

		try {
			this.setState({ isGettingCreditCardInstallmentOptions: true })

			const creditCardInstallmentsOptions = await getCreditCardInstallmentOptions(
				orderValue
			)

			this.installmentFetchRetries = 0

			this.setState({
				isGettingCreditCardInstallmentOptions: false,
				fetchedCreditCardInstallmentOptions: true
			})

			if (creditCardInstallmentsOptions) {
				this.props.setInstallmentsOptions(creditCardInstallmentsOptions)

				const optionExists = creditCardInstallmentsOptions.some(
					opt => String(opt.value) === String(installmentsQtt)
				)

				if (installmentsQtt && optionExists) {
					this.props.setFieldValue('installments', installmentsQtt)
					this.setInterestValue(installmentsQtt)
				} else {
					this.props.setInstallmentsQtt(null)
					this.props.setFieldValue('installments', '')
				}
			}
		} catch (error) {
			this.setState({
				isGettingCreditCardInstallmentOptions: false,
				fetchedCreditCardInstallmentOptions: false
			})

			if (this.installmentFetchRetries >= MAX_INSTALLMENT_FETCH_RETRIES) {
				return
			}
			this.installmentFetchRetries += 1

			if (showToast) {
				this.props.toastWarning({
					message:
						'Estamos tentando buscar as opções de parcelamento, aguarde alguns instantes.'
				})
			}

			await new Promise(resolve => setTimeout(resolve, 5000))
			await this.fetchInstallmentOptions(orderValue, false)
		}
	}

	async componentDidMount() {
		this._isMounted = true
		if (!this.state.fetchedCreditCardInstallmentOptions) {
			await this.fetchInstallmentOptions(this.props.orderValue)
		}
	}

	async componentDidUpdate(prevProps) {
		if (
			prevProps.orderValue !== this.props.orderValue ||
			prevProps.apiInstallments !== this.props.apiInstallments ||
			prevProps.apiPaymentMethodsLoading !== this.props.apiPaymentMethodsLoading
		) {
			// Um novo valor/origem de dados merece seu proprio orcamento de retries,
			// em vez de ficar bloqueado pelo contador de uma tentativa anterior.
			if (prevProps.orderValue !== this.props.orderValue) {
				this.installmentFetchRetries = 0
			}
			await this.fetchInstallmentOptions(this.props.orderValue)
		}
	}

	renderCreditCardInput = () => {
		if (this.state.selectedCardBrand === cardBrand.amex)
			return (
				<AmexCreditCardInput
					{...this.props}
					id="cardNumber"
					className="cardNumber"
					label="Número do cartão"
					onComplete={creditCardNumber =>
						this.props.setCreditCardNumber(creditCardNumber)
					}
				/>
			)
		else
			return (
				<CreditCardInput
					{...this.props}
					id="cardNumber"
					className="cardNumber"
					label="Número do cartão"
					onComplete={creditCardNumber =>
						this.props.setCreditCardNumber(creditCardNumber)
					}
				/>
			)
	}

	setInterestValue(installment) {
		this.props.setInterestRate(installment)
	}

	render() {
		const {
			selectedCardBrand,
			isGettingCreditCardInstallmentOptions
		} = this.state

		const {
			user,
			source,
			recurrent,
			noSecurityCode,
			noInstallments,
			noInstallmentsMessage,
			isCalculatingValues,
			installmentsOptions,
			installmentsQtt
		} = this.props

		const fetchingInstallmentOptions =
			!installmentsOptions.length ||
			isCalculatingValues ||
			isGettingCreditCardInstallmentOptions

		return (
			<React.Fragment>
				<p className="blue">Informações do cartão</p>
				<StyledPaymentMethodsButtons isCardBrands>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.mastercard}
						onClick={() => this.selectCardBrand(cardBrand.mastercard)}>
						<StyledContent>
							<MasterCardIcon
								disabled={selectedCardBrand !== cardBrand.mastercard}
							/>
						</StyledContent>
					</RadioButton>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.visa}
						onClick={() => this.selectCardBrand(cardBrand.visa)}>
						<StyledContent>
							<VisaIcon
								disabled={selectedCardBrand !== cardBrand.visa}
							/>
						</StyledContent>
					</RadioButton>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.elo}
						onClick={() => this.selectCardBrand(cardBrand.elo)}>
						<StyledContent>
							<EloIcon disabled={selectedCardBrand !== cardBrand.elo} />
						</StyledContent>
					</RadioButton>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.amex}
						onClick={() => this.selectCardBrand(cardBrand.amex)}>
						<StyledContent>
							<AmexIcon
								disabled={selectedCardBrand !== cardBrand.amex}
							/>
						</StyledContent>
					</RadioButton>
					<RadioButton
						isActive={selectedCardBrand == cardBrand.hipercard}
						onClick={() => this.selectCardBrand(cardBrand.hipercard)}>
						<StyledContent>
							<HipercardIcon
								disabled={selectedCardBrand !== cardBrand.hipercard}
							/>
						</StyledContent>
					</RadioButton>
				</StyledPaymentMethodsButtons>
				<StyledFieldsContainer noSecurityCode={noSecurityCode}>
					<StyledCardFields
						style={
							noSecurityCode && { gridTemplateColumns: 'repeat(4, 1fr)' }
						}>
						{recurrent ? (
							<div className="recurrent-pay-day">
								<PureSelect
									id="recurrentPayDay"
									placeholder="Selecione..."
									className="recurrent-pay-day"
									options={this.recurrentPayDayOptions}
									label="Data de cobrança a partir do próximo mês"
									{...this.props}
								/>
								<p style={{ fontSize: '15px' }}>
									Nessa data os pontos estarão disponíveis na sua
									conta. A renovação é automática.
								</p>
							</div>
						) : (
							noInstallments || (
								<PureSelect
									{...this.props}
									id="installments"
									label="Parcelamento"
									className="installments"
									placeholder={
										fetchingInstallmentOptions
											? 'Calculando...'
											: 'Selecione...'
									}
									options={installmentsOptions}
									handleChange={e => {
										const installment = e.target.value

										if (installment) {
											this.props.setInstallmentsQtt(installment)
											this.setInterestValue(installment)
										}

										return this.props.handleChange(e)
									}}
									noOptionsMessage={noInstallmentsMessage}
									disabled={fetchingInstallmentOptions}
								/>
							)
						)}
						<TextInput
							id="cardPrintedName"
							className="cardPrintedName"
							label="Nome impresso no cartão"
							maxLength={26}
							style={{ textTransform: 'uppercase' }}
							normalize
							{...this.props}
						/>
						{this.renderCreditCardInput()}
						<PureSelect
							id="cardMonthValidity"
							className="card-month-validity validity-field"
							label="Validade"
							placeholder="Mês"
							options={[
								{ value: '01', label: '01' },
								{ value: '02', label: '02' },
								{ value: '03', label: '03' },
								{ value: '04', label: '04' },
								{ value: '05', label: '05' },
								{ value: '06', label: '06' },
								{ value: '07', label: '07' },
								{ value: '08', label: '08' },
								{ value: '09', label: '09' },
								{ value: '10', label: '10' },
								{ value: '11', label: '11' },
								{ value: '12', label: '12' }
							]}
							{...this.props}
						/>
						<PureSelect
							id="cardYearValidity"
							className="card-year-validity validity-field"
							placeholder="Ano"
							options={cardYearValidityOptions}
							{...this.props}
						/>
						{noSecurityCode || (
							<SecurityCodeInput
								id="securityCode"
								className="security-code"
								label="Cód. de segurança"
								maxLength={4}
								{...this.props}
							/>
						)}
						{user !== null ? (
							source !== 'add-card-modal' ? (
								<CheckboxToggleInput
									label="Salvar dados do cartão para compras futuras"
									id="savecard"
									className="savecard-container"
									{...this.props}
								/>
							) : null
						) : null}
					</StyledCardFields>
				</StyledFieldsContainer>
			</React.Fragment>
		)
	}
}

const mapStateToProps = store => ({
	user: store.user,
	cardBrand: store.creditCardPurchase.cardBrand,
	creditCardNumber: store.creditCardPurchase.creditCardNumber,
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	installmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(
		store.creditCardPurchase
	),
	installmentsOptions: CreditCardPurchaseSelectors.getInstallmentsOptions(
		store.creditCardPurchase
	)
})
const mapDispatchToProps = {
	setCardBrand: CreditCardPurchaseCreators.setCardBrand,
	setCreditCardNumber: CreditCardPurchaseCreators.setCreditCardNumber,
	setInstallmentsQtt: CreditCardPurchaseCreators.setInstallmentsQtt,
	setInterestRate: CreditCardPurchaseCreators.setInterestRate,
	setInstallmentsOptions: CreditCardPurchaseCreators.setInstallmentsOptions,
	toastWarning: toastActions.warning
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardFields)
